import { render, staticRenderFns } from "./Recount__plotsBv.vue?vue&type=template&id=72b83360&scoped=true&"
import script from "./Recount__plotsBv.vue?vue&type=script&lang=js&"
export * from "./Recount__plotsBv.vue?vue&type=script&lang=js&"
import style0 from "./Recount__plotsBv.vue?vue&type=style&index=0&id=72b83360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b83360",
  null
  
)

export default component.exports